import { render } from "./MadeByComponent.vue?vue&type=template&id=168d37e0"
import script from "./MadeByComponent.vue?vue&type=script&lang=js"
export * from "./MadeByComponent.vue?vue&type=script&lang=js"

import "./MadeByComponent.vue?vue&type=style&index=0&id=168d37e0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__